const translations = {
    battery: 'Battery',
    battery_other: 'Batteries',
    drone: 'Drone',
    drone_other: 'Drones'
};

export default translations;
